import * as React from 'react';
import { Component } from 'react';
import * as ReactDocumentEvent from 'react-document-events';
import throttle = require('lodash/throttle');
import { Portal } from 'react-portal';
import { FixedContainer } from './StickyContainer.s';
import { getScrollTop } from '@utils/index';

type ChildrenParams = {
  position: number;
  start: number;
  end: number;
  max: number;
};

type StickyContainerProps = {
  start: number;
  end: number;
  margin: number;
  windowHeight: number;
  children: (params: ChildrenParams) => JSX.Element;
};

type StickyContainerState = {
  isVisible: boolean;
  position: number;
};

export class StickyContainer extends Component<StickyContainerProps, StickyContainerState> {
  constructor(props: StickyContainerProps) {
    super(props);

    this.onScroll = throttle(this.onScroll, 10).bind(this);
    this.state = {
      isVisible: false,
      position: this.computePosition(props),
    };
  }

  componentWillReceiveProps(nextProps: StickyContainerProps) {
    this.update(nextProps);
  }

  render(): JSX.Element | null {
    return (
      <div>
        <ReactDocumentEvent target={window} onScroll={this.onScroll} />
        {this.state.isVisible && (
          <Portal>
            <FixedContainer>
              {this.state.isVisible &&
                this.props.children({
                  position: this.state.position,
                  start: this.props.start,
                  end: this.props.end,
                  max: this.props.end - this.props.start,
                })}
            </FixedContainer>
          </Portal>
        )}
      </div>
    );
  }

  private onScroll(): void {
    this.update(this.props);
  }

  private update(props: StickyContainerProps): void {
    const { start, end, margin, windowHeight } = props;
    const startWindow = start - windowHeight;
    const scroll = getScrollTop();
    const shouldBeVisible = scroll > startWindow - margin && scroll < end + margin;
    if (this.state.isVisible !== shouldBeVisible) {
      this.setState({ isVisible: shouldBeVisible });
    }
    if (shouldBeVisible) {
      const position = this.computePosition(props);
      this.setState({ position });
    }
  }

  private computePosition(props: StickyContainerProps): number {
    const { start, windowHeight } = props;
    const startWindow = start - windowHeight;
    const scroll = getScrollTop();
    return scroll - startWindow;
  }
}



// WEBPACK FOOTER //
// src/app/src/components/StickyContainer/StickyContainer.tsx